(function () {
    'use strict';

    angular.module("imApp").factory("consignmentLinesBService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 756,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 757,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
